import { Plus, Minus } from "lucide-react";
import { useCountryTranslations } from "../contexts/CountryTranslationsContext";

interface ScoreInputProps {
  value: number;
  onChange: (value: number) => void;
  teamName: string;
  teamFlag: string;
  disabled?: boolean;
}

export function ScoreInput({
  value,
  onChange,
  teamName,
  teamFlag,
  disabled = false,
}: ScoreInputProps) {
  const { getCountryName } = useCountryTranslations();
  const translatedTeamName = getCountryName(teamName);

  const handleIncrement = () => {
    if (!disabled && value < 9) onChange(value + 1);
  };

  const handleDecrement = () => {
    if (!disabled && value > 0) onChange(value - 1);
  };

  return (
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-1.5 sm:gap-2 md:gap-3">
        <button
          onClick={handleDecrement}
          disabled={disabled}
          className={`w-10 h-10 sm:w-11 sm:h-12 md:w-12 md:h-14 flex-shrink-0 rounded-lg sm:rounded-xl bg-white transition-smooth flex items-center justify-center border-2 ${
            disabled
              ? "border-slate-200 opacity-50 cursor-not-allowed"
              : "border-slate-200 hover:bg-slate-50 active:scale-95"
          }`}
          aria-label="Decrease score"
        >
          <Minus className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-slate-600" />
        </button>
        <div
          className={`flex-1 min-w-[45px] sm:min-w-[55px] h-10 sm:h-12 md:h-14 flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 border-2 border-slate-200 rounded-xl sm:rounded-2xl ${
            disabled ? "opacity-75" : ""
          }`}
        >
          <span className="text-xl sm:text-2xl md:text-3xl font-bold text-primary leading-none">
            {value}
          </span>
        </div>
        <button
          onClick={handleIncrement}
          disabled={disabled}
          className={`w-10 h-10 sm:w-11 sm:h-12 md:w-12 md:h-14 flex-shrink-0 rounded-lg sm:rounded-xl transition-smooth flex items-center justify-center ${
            disabled
              ? "bg-slate-200 opacity-50 cursor-not-allowed"
              : "bg-gradient-to-br from-primary to-primary-dark hover:shadow-md active:scale-95"
          }`}
          aria-label="Increase score"
        >
          <Plus
            className={`w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 ${
              disabled ? "text-slate-400" : "text-white"
            }`}
          />
        </button>
      </div>
    </div>
  );
}
